import * as angular from "angular";
import { Utils } from "../../helper/utils.helper";

let ChooseImportComponent = {
    selector: "vcChooseImport",
    templateUrl:
        "/angular/components/nation-builder/choose-import.component.html",
    bindings: {},
    controller: class ChooseImportController {
        public __env: any;
        public utils: Utils;

        constructor(__env: any, Utils: Utils) {
            this.__env = __env;
            this.utils = Utils;
        }
    },
};

angular
    .module("nationBuilder", [])
    .component(ChooseImportComponent.selector, ChooseImportComponent);
